let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l6WEm")).then(() => parcelRequire('dAPjL'));